export enum PositionStatus {
  MOVING = 'MOVING',
  PARKING = 'PARKING',
  INACTIVE = 'INACTIVE'
}
